import { ValidatorOptions } from '.';
import { RequiredValidator } from './required.validator';
import { ValidationResult } from './types.validators';
import { Validator } from './validator';

export class AlphaNumericValidator extends Validator {
    public validate(value: string, options: ValidatorOptions): ValidationResult {
        if (!value || value.length < 1) {
            return new RequiredValidator().validate(value, options);
        }

        const alphaNumericRegex = /^[a-zA-Z0-9]*$/;
        const isValid = alphaNumericRegex.test(value ?? '');
        if (!isValid) {
            return new ValidationResult(false, 'Please enter a valid alpha-numeric value');
        }

        return new ValidationResult(true);
    }
}
